import * as React from 'react';

import ManageContent32 from './ManageContent32';

export const manageContent32 = () => <ManageContent32 />;

export default {
    title: 'Icon/Logo/ManageContent32',
    component: ManageContent32,
    parameters: {
        notes: "`import ManageContent32 from 'box-ui-elements/es/icon/logo/ManageContent32';`",
    },
};
